import Couteau_evenement from './images/Couteua-evenement.png'
import OutilsEvent from './Outils-evenement'

export default function couteau_communication() {
    const SolutionEvenement = (
        <>
            <div className='content-solution'>
                <div className='solution-titre'>ÉVÉNEMENTIEL</div>
                <div className='solution-img-container'><img className='image-solution' src={Couteau_evenement} /></div>
            </div>
            <div className='outil-1'>
                <div className='solution-body-event'>
                    <OutilsEvent />
                </div>
            </div>
        </>
    );
    return SolutionEvenement
}